<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка супов</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Горячий суп — идеально подходит как на обед, так и на ужин. На <a href="/">хочу-поесть.рф</a>. Вы можете заказать Ваш любимый суп по самой низкой цене. Сравните цены в ресторанах и выберите наиболее приятную.</p>
            <p>У нас есть супы на любой вкус! Закажите суп Фо, мисо суп, крем-суп или любой другой. Отличным дополнением к супу станет салат и вкусный напиток.</p>
            <p>На нашем сайте Вы также можете заказать <a href="/sushi">роллы</a>, <a href="/pizza">пиццу</a>  или любые другие блюда с доставкой на дом или в офис. А на третье <a href="/dessert">вкусный десерт</a> с ароматным кофе прямо из лучших кондитерских Вашего города.</p>
            <p>Благодаря таймеру на сайте, можно оформить доставку прямо сейчас, а мы привезем еду в нужное Вам время. Это очень удобно, если Вы проголодались в офисе или по пути домой!</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'soups'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/soups.vue